import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import styled from 'styled-components';
import { stringIsNotEmpty } from '../../utils/content-formatting';

const SpacedImage = styled.img`
  margin-bottom: ${({ theme, $addMarginBottom }) =>
    $addMarginBottom ? theme.spacing.standard : 0};
`;

const Image = ({
  image,
  className,
  width,
  height,
  fit,
  presentational,
  addMarginBottom,
}) => {
  if (!image) return null;

  const { description, file } = image;
  if (!file || !file.url) return null;

  const { url } = file;
  const params = queryString.stringify({
    h: height,
    w: width,
    fit,
  });

  return (
    <picture>
      <source
        srcSet={`${url}?fm=avif&q=95${params ? `&${params}` : ''}`}
        type="image/avif"
      />
      <source
        srcSet={`${url}?fm=webp&q=95${params ? `&${params}` : ''}`}
        type="image/webp"
      />
      <SpacedImage
        alt={
          !presentational && stringIsNotEmpty(description) ? description : ''
        }
        className={className}
        loading={process.env.VRT ? 'eager' : 'lazy'}
        $addMarginBottom={addMarginBottom}
        src={`${url}?q=95${params ? `&${params}` : ''}`}
      />
    </picture>
  );
};

Image.propTypes = {
  image: PropTypes.shape({
    description: PropTypes.string,
    title: PropTypes.string,
    file: PropTypes.shape({
      contentType: PropTypes.string,
      fileName: PropTypes.string,
      url: PropTypes.string.isRequired,
    }).isRequired,
  }),
  addMarginBottom: PropTypes.bool,
  className: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number,
  fit: PropTypes.oneOf(['pad', 'fill', 'scale', 'crop', 'thumb']),
  presentational: PropTypes.bool,
};

export default Image;
